// @flow
import React from 'react';

import { useRouterParamsE } from 'app/common/context/WithRouterParams';
import { CheckoutButton } from 'app/common/layouts/commonShop';


/**
 * Редирект на подробный вид заказа c оплатой
 */

type Props = {
  id: string,
  number: string,
  className?: string,
}

const OrderDetailsButton = ({
  id,
  number,
  className,
}: Props) => {
  const { baseUrl } = useRouterParamsE([]); // TODO переделать на useRouterParams (почему то не работало)
  const to = `${baseUrl}/order/${id}/${number}`;

  return (
    <CheckoutButton
      className={className}
      to={to}
      disabled={!id}
      submit
    >
      {'Оплатить'}
    </CheckoutButton>
  );
};

export default OrderDetailsButton;
